(function ($) {
  var pdfCards = $('.pdf-cards');
  var pdfCardTitle = $('.pdf-card p');

  if (pdfCards.length > 0) {

    $(window).on('resize load', function () {
      pdfCardTitle.matchHeight();
    }) 
  }
})(jQuery);